module.exports = __webpack_public_path__ + "img/gonetwork2_3.790c7bb4.png";